import React, { useState, useRef } from 'react';
import { Modal, message } from 'antd';
import { useParams } from 'react-router-dom';
import { EpisodeTypeList, OtomeEpisodeTypeList } from 'utils/constant';
import { theme } from 'utils/style/theme';
import { episodeApi } from 'apis/story/episodeApis';
import VerticalForm from 'components/form/DefaultForm';
import DefaultRadio from 'components/input/DefaultRadio';
import DefaultInput from 'components/input/DefaultInput';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import PrimaryButton from 'components/button/PrimaryButton';
/**
 * * 에피소드 & 오토메 에피 등록 모달
 */
interface IEpisodeProp {
  title: string;
  episode_type: string;
}
interface IProps {
  visible: boolean;
  setVisible: (e: any) => void;
  lang: string;
  fetchData: () => void;
}
const EpisodeRegisterModal: React.FC<IProps> = ({
  visible,
  setVisible,
  fetchData,
}) => {
  const { t } = useTranslation();
  const { projectId } = useParams();
  const [inputData, setInputData] = useState<IEpisodeProp>({
    title: '',
    episode_type: 'chapter',
  });
  const inputRef = useRef<HTMLInputElement[]>([]);

  /// 인풋
  const handleInputChange = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const [loading, setLoading] = useState(false);

  /// 등록하기
  const handleSubmit = async () => {
    if (inputData?.title === '') {
      inputRef?.current[1]?.focus();
      message.error('에피소드 제목을 입력하세요.', 1);
      return;
    }
    try {
      setLoading(true);
      await episodeApi.register(projectId, inputData);
      setVisible(false);
      fetchData();
      setInputData({ title: '', episode_type: 'chapter' });
      setLoading(false);
      message.success('에피소드가 등록되었습니다.', 1);
    } catch (err) {
      setLoading(false);
      console.log('create episode error:', err);
    }
  };

  /// 모달 닫기
  const handleCancel = () => {
    setVisible(false);
    setInputData({ title: '', episode_type: 'chapter' });
  };

  const otomeEpisodeTypeData = OtomeEpisodeTypeList();

  return (
    <CustomModal
      title={t(
        'storyEpisodeID.storyTabMenuList.episodeContent.header.registerEpisodeModal.episodeRegistration',
      )}
      visible={visible}
      onCancel={handleCancel}
      footer={
        <FooterBtnWrapper>
          <PrimaryButton
            text={t(
              'storyEpisodeID.storyTabMenuList.episodeContent.header.registerEpisodeModal.register',
            )}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.primary}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.primary}`}
            rounded='6px'
            hoverBgColor={theme.colors.primary}
            activeBgColor={theme.colors.primary}
            selectedBgColor={theme.colors.primary}
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
          />
        </FooterBtnWrapper>
      }
    >
      <VerticalForm margin='0'>
        <DefaultRadio
          title={t(
            'storyEpisodeID.storyTabMenuList.episodeContent.header.registerEpisodeModal.episodeType',
          )}
          name='episode_type'
          optionList={otomeEpisodeTypeData}
          defaultValue={inputData?.episode_type}
          onChange={handleInputChange}
          ref={(el) => (inputRef.current[0] = el)}
        />

        <DefaultInput
          title={t(
            'storyEpisodeID.storyTabMenuList.episodeContent.header.registerEpisodeModal.episodeTitle',
          )}
          name='title'
          maxLength={60}
          value={inputData.title}
          onChange={handleInputChange}
          ref={(el: HTMLInputElement) => (inputRef.current[1] = el)}
          noMarginBottom
        />
        <p className='length-subtext'>
          {typeof inputData.title?.length === 'number'
            ? `${inputData.title?.length}/30 characters`
            : '0/30 characters'}
        </p>
      </VerticalForm>
    </CustomModal>
  );
};

export default EpisodeRegisterModal;

const CustomModal = styled(Modal)`
  .length-subtext {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    margin-top: 8px !important;
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200};
  }
  .ant-modal-body {
    padding: 0;
  }
  label {
    margin-left: 0;
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.medium};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_500};
    margin-bottom: 8px !important;
  }
  .ant-modal-content {
    box-shadow: none;
  }
  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }
  .ant-modal-footer {
    margin-top: 10px !important;
  }
  .ant-input-show-count-suffix {
    display: none;
  }
`;

const FooterBtnWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
